import { render } from "./ReporteInteraccionUsuario.vue?vue&type=template&id=8be6fbfc"
import script from "./ReporteInteraccionUsuario.vue?vue&type=script&lang=js"
export * from "./ReporteInteraccionUsuario.vue?vue&type=script&lang=js"

import "./ReporteInteraccionUsuario.vue?vue&type=style&index=0&id=8be6fbfc&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__